import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { Capacitor } from '@capacitor/core';
import appReducer from './app';
import uiReducer from './ui';
import entitiesReducer from './entities';
import aggregatesReducer from './aggregates';
import miscReducer from './misc';
import tableOptionsReducer from './tableOptions';
import calendarOptionsReducer from './calendarOptions';
import CapacitorStorage from '../store/capacitorStorage';

const rootReducer = combineReducers({
  app: appReducer,
  ui: persistReducer(
    {
      key: 'ui',
      storage: Capacitor.isNativePlatform() ? CapacitorStorage : storage,
      whitelist: ['persisted', 'filters', 'courses'],
    },
    uiReducer
  ),
  entities: entitiesReducer,
  aggregates: aggregatesReducer,
  tableOptions: persistReducer(
    {
      key: 'tableOptions',
      storage: Capacitor.isNativePlatform() ? CapacitorStorage : storage,
    },
    tableOptionsReducer
  ),
  calendarOptions: persistReducer(
    {
      key: 'calendarOptions',
      storage: Capacitor.isNativePlatform() ? CapacitorStorage : storage,
    },
    calendarOptionsReducer
  ),
  misc: miscReducer,
});

export default rootReducer;
